export enum ClientType {
  Active,
  Inactive,
  Test,
}

export const ClientTypeLookup = {
  Active: ClientType.Active,
  Inactive: ClientType.Inactive,
  Test: ClientType.Test,
} as Record<string, ClientType>;

export const ClientTypeReverseLookup = {
  [ClientType.Active]: "Active",
  [ClientType.Inactive]: "Inactive",
  [ClientType.Test]: "Test",
} as Record<ClientType, string>;
